export default "__VITE_ASSET__D5sQ0$Ne__"